import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  label {
    font-family: ${({ theme }) => theme.fonts.titleBold};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 8px;
  }

  span.danger {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.titleBold};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.danger};
    margin: 4px 0;
  }
`;
